module.exports = __webpack_public_path__ + "static/media/ico_firmaya_desktop.18968cca.svg";